import React, { useEffect, useState } from "react";
import { CheckCircle, XCircle, AlertTriangle, X } from "lucide-react";

const typeStyles = {
  success: {
    icon: CheckCircle,
    iconColor: "text-status-success",
    bgColor: "bg-status-success/10 border-status-success",
    textColor: "text-status-success",
  },
  error: {
    icon: XCircle,
    iconColor: "text-status-error",
    bgColor: "bg-status-error/10 border-status-error",
    textColor: "text-status-error",
  },
  warning: {
    icon: AlertTriangle,
    iconColor: "text-status-warning",
    bgColor: "bg-status-warning/10 border-status-warning",
    textColor: "text-status-warning",
  },
};

const ToastItem = ({ id, type, message, onDismiss }) => {
  const [isDismissing, setIsDismissing] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const entryTimer = setTimeout(() => {
      setMounted(true);
    }, 10);

    const autoTimer = setTimeout(() => {
      startDismiss();
    }, 3000);

    return () => {
      clearTimeout(autoTimer);
      clearTimeout(entryTimer);
    };
  }, );

  const startDismiss = () => {
    if (isDismissing) return;
    setIsDismissing(true);
    setTimeout(() => {
      onDismiss();
    }, 300);
  };

  const {
    icon: Icon,
    iconColor,
    bgColor,
    textColor,
  } = typeStyles[type] || typeStyles.success;

  const animationClass = isDismissing
    ? "opacity-0 translate-x-6"
    : mounted
    ? "opacity-100 translate-x-0"
    : "opacity-0 translate-x-6";

  return (
    <div
      className={`transition-all duration-300 ease-in-out will-change-transform`}
    >
      <div
        className={`transition-all duration-300 ease-out transform ${animationClass} border px-4 py-3 rounded-lg shadow-md flex items-center gap-3 w-full max-w-sm ${bgColor}`}
      >
        <Icon size={20} className={iconColor} />
        <p className={`text-sm font-medium ${textColor} flex-1`}>{message}</p>
        <button
          onClick={startDismiss}
          className="text-text-muted hover:text-white transition"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default ToastItem;
